import React, {useEffect, useRef, useState} from 'react'
import {useParams} from "react-router";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import Loading from "components/Loading";
import {makeStyles} from "@material-ui/styles";
import {connect} from "react-redux";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import DemandValidationMessages from "components/DemandValidationMessages";
import scheduleReloadTimeout from "../../../utils/scheduleReloadTimeout";
import {PurchasingGroupStageSections} from "../../../constants/PurchasingGroupStageSections";
import UserService from "services/UserService";
import PurchasingGroupStage2Service from "services/PurchasingGroupStage2Service";
import GridBlock from "components/GridBlock";
import BoldTypography from "components/BoldTypography";
import Tr from "translations/Translations";
import SelectOrganization from "components/popup/selectOrganization/SelectOrganization";
import WorkableButton from "components/button/WorkableButton";
import useSnackbar from "hooks/useSnackbar";
import TemplateMembersList from "./components/TemplateMembersList";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import reduxStore from "redux/store"
import {PurchasingGroupRole} from "../../../constants/PurchasingGroupRole";

const useStyle = makeStyles(theme => ({
    root: {
        width: "100%"
    },
    marginLeft: {
        marginLeft: theme.spacing(2)
    }
}))

function PurchasingGroupStage2Template(
    {
        panelRef,
        validationSection,
        template,
        purchasingGroupHeader,
        stageSections
    }) {
    const classes = useStyle();
    const params = useParams();
    const groupId = params.id;
    const formIdPrefix = params.section;
    const [availableTemplates, setAvailableTemplates] = useState(null);
    const timeout = useRef(0);
    const coordinatorView = purchasingGroupHeader.userRole === PurchasingGroupRole.MEMBER;
    const editable = validationSection.editable;
    const {enqueueSuccessSnackbar} = useSnackbar();

    useStepperStateCloseValidator(formIdPrefix, () => {
        const formValues = reduxStore.getState()?.formValues;
        const index = Object.keys(formValues).findIndex(formId => formId.startsWith(formIdPrefix) && formId.endsWith("_dirty") && formValues[formId] === true);
        return index === -1;
    });


    const getTemplate = () => {
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = 0;
        }
        PurchasingGroupStage2Service.getTemplate(groupId);

        const mainSection = stageSections[PurchasingGroupStageSections.STAGE_2_SECTION];
        if (mainSection && mainSection.schedule) {
            UserService.serverTime().then(serverTime => {
                let reloadTimeout = scheduleReloadTimeout(mainSection.schedule, serverTime);
                if (reloadTimeout) {
                    timeout.current = setTimeout(() => {
                        getTemplate();
                    }, reloadTimeout)
                }
            })
        }
    }

    useEffect(() => {
        getTemplate();
        PurchasingGroupSectionService.getSections(groupId, validationSection.section)
        return () => {
            if (timeout.current) {
                clearTimeout(timeout.current);
                timeout.current = 0;
            }
            PurchasingGroupStage2Service.clearResources(PurchasingGroupStage2Service.PURCHASING_GROUP_TEMPLATE_RESOURCE_ID)
        }
        // eslint-disable-next-line
    }, [groupId])

    const loadAvailableTemplates = () => {
        PurchasingGroupStage2Service.getAvailableTemplates(groupId).then((resp) => setAvailableTemplates(resp))
    }
    const onTemplateSelect = (value) => {
        setAvailableTemplates(null);
        PurchasingGroupStage2Service.saveTemplate(groupId, {templateId: value.orgId, templateName: value.name})
            .then((resp) => {
                if (resp) {
                    enqueueSuccessSnackbar(Tr("saved"));
                    PurchasingGroupSectionService.getSections(groupId, validationSection.section)
                }
            });
    }

    if (!template) return <Loading/>

    return (
        <div className={classes.root}>
            {!coordinatorView && <DemandValidationMessages editable={validationSection.editable} section={validationSection}/>}
            {!coordinatorView && <GridBlock alignItems="center">
                {template.canChooseTemplate &&
                    <WorkableButton onClick={loadAvailableTemplates}>{Tr("choose_template")}</WorkableButton>
                }
                {template.templateId > 0 &&
                    <BoldTypography className={classes.marginLeft}>{Tr("chosen_template")}: {template.templateName}</BoldTypography>
                }
            </GridBlock>}

            <TemplateMembersList
                validationSection={validationSection}
                editable={editable && template.canFillForm}
                members={template.memberList}
                coordinatorView={coordinatorView}
                groupId={groupId}
                formIdPrefix={formIdPrefix}
            />


            {!!availableTemplates &&
                <SelectOrganization
                    initOrganization={{orgId: null, name: null}}
                    availableOrganizations={availableTemplates.map(x => ({orgId: "" + x.templateId, name: x.templateName}))}
                    onCancel={() => setAvailableTemplates(null)}
                    onConfirm={onTemplateSelect}
                    open
                    title="choose_template"
                />
            }
        </div>
    )
}

PurchasingGroupStage2Template.propTypes = {}

export default connect((state) => ({
    stageSections: state.resources[PurchasingGroupSectionService.PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID],
    template: state.resources[PurchasingGroupStage2Service.PURCHASING_GROUP_TEMPLATE_RESOURCE_ID],
    purchasingGroupHeader: state.resources[PurchasingGroupStage1Service.PURCHASING_GROUP_HEADER_RESOURCE_ID]
}), {})(PurchasingGroupStage2Template);